//RELOAD
export const RELOAD_SET = "RELOAD_SET";
export const RELOAD_SET_LAST = "RELOAD_SET_LAST";

//FILTER
export const FILTER_SET = "FILTER_SET";
export const FILTER_RESET = "FILTER_RESET";

//SESSION
export const GET_USER_SESSION_SUCCESS = "GET_USER_SESSION_SUCCESS";
export const GET_USER_SESSION_ERROR = "GET_USER_SESSION_ERROR";

//LANGUAGE
export const LANGUAGE_SET = "LANGUAGE_SET";
export const LANGUAGE_RESET = "LANGUAGE_RESET";
